<template>
    <v-container fluid>
        <v-card class="ma-2" outlined>
            <v-card-title>
                <v-icon class="mr-1" color="green">mdi-text-box-check</v-icon>
                Online Survey
                <v-btn color="primary" dark class="ml-5 mt-3" @click="onExport" :loading="this.isExporting">
                    Export json
                </v-btn>
            </v-card-title>
        </v-card>
    </v-container>
    </template>
    
    <script>
    import firebase from "firebase/compat/app";
    import "firebase/compat/auth";
    import {
        mapGetters
    } from "vuex";
    import {
        getFunctions,
        httpsCallable
    } from "firebase/functions";
    export default {
        name: 'OnlineSurvey',
        metaInfo: {
            title: 'Online Survey'
        },
        data() {
            return {
                isExporting: false,
                loading: false
            };
        },
        created() {
            var vm = this;
            vm.$store.state.appTitle = "Thaisook Web Admin | Online survey";
            firebase.auth().onAuthStateChanged((user) => {
                if (user) {
                    vm.$store.dispatch("autoSignIn", user);
                    this.loading = true;
                    setTimeout(() => {
                        vm.initialize();
                    }, "1000");
                } else {
                    console.log("no user");
                }
            });
        },
        computed: {
            ...mapGetters([
                "loggedInUserId",
                "isAuthenticated",
                "isSuperAdmin",
                "isChallengeAdmin",
                "isAccessOnlineSurvey"
            ]),
        },
        methods: {
            initialize() {
                this.loading = false;
                if (!this.isSuperAdmin && !this.isAccessOnlineSurvey) {
                    this.$router.push(`/dashboard`);
                }
            },
            onExport() {
                this.isExporting = true;
                const app = firebase.app();
                const functions = getFunctions(app, 'asia-east2');
                const queryThaisookViewBigQuery = httpsCallable(functions, 'queryThaisookViewBigQuery');

                const prefixFileName = `online-survey-`;
                const downloadUrl = `https://storage.googleapis.com/thaisook_bigquery_export/${prefixFileName}000000000000.json`;

                queryThaisookViewBigQuery({
                        query: `
                        EXPORT DATA OPTIONS (
                            uri='gs://thaisook_bigquery_export/${prefixFileName}*.json',
                            format='json',
                            overwrite=true
                        ) AS (
                            SELECT ARRAY_AGG(data) data FROM firestore_thaisook.online_survey_raw_latest
                        )
                    `
                    })
                    .then((result) => {
                        this.isExporting = false;
                        const resultData = JSON.parse(result.data);
                        if (resultData.errors) {
                            // alert(resultData.errors);
                        } else {
                            const d = new Date();
                            window.location = downloadUrl + '?t=' + d.getTime();
                        }
                    });
            }
        },
    };
    </script>